import { render, staticRenderFns } from "./evaluate-list.vue?vue&type=template&id=63779b2a&scoped=true"
import script from "./evaluate-list.vue?vue&type=script&lang=js"
export * from "./evaluate-list.vue?vue&type=script&lang=js"
import style0 from "./evaluate-list.vue?vue&type=style&index=0&id=63779b2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63779b2a",
  null
  
)

export default component.exports